import type { GpsStatus } from './engine/tracking-engine';
import { useT } from '../../i18n';

const LABEL: Record<GpsStatus, string> = {
  off: 'GPS off',
  searching: 'Searching GPS…',
  good: 'GPS good',
  fair: 'GPS fair',
  poor: 'GPS weak',
  denied: 'Location blocked',
  unavailable: 'GPS unavailable',
};

const COLOR: Record<GpsStatus, string> = {
  off: 'bg-ink-700 text-ink-300',
  searching: 'bg-sky/15 text-sky',
  good: 'bg-volt/15 text-volt',
  fair: 'bg-gold/15 text-gold',
  poor: 'bg-enemy/15 text-enemy',
  denied: 'bg-enemy/15 text-enemy',
  unavailable: 'bg-enemy/15 text-enemy',
};

export function GpsChip({ status, accuracy }: { status: GpsStatus; accuracy?: number | null }) {
  const t = useT();
  const showAcc = accuracy != null && (status === 'good' || status === 'fair' || status === 'poor');
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wider ${COLOR[status]}`}
      data-testid="gps-chip"
      data-status={status}
    >
      <span className={`size-2 rounded-full bg-current ${status === 'searching' ? 'animate-pulse' : ''}`} />
      {t(LABEL[status])}
      {showAcc ? <span className="tabular">±{Math.round(accuracy!)} m</span> : null}
    </span>
  );
}
